import { css } from '@emotion/react';

const styles = css`
  overflow: auto;
  flex: 1;
  padding: var(--cds-spacing-50);

  ul& {
    list-style: none;
    margin: 0;
    padding: 0;
  }
`;

export default styles;
